import { render, staticRenderFns } from "./follower.vue?vue&type=template&id=784212a1&scoped=true&"
import script from "./follower.vue?vue&type=script&lang=js&"
export * from "./follower.vue?vue&type=script&lang=js&"
import style0 from "./follower.vue?vue&type=style&index=0&id=784212a1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784212a1",
  null
  
)

export default component.exports